const DrivingLicenseIconWithWhiteBG = () => {
  return (
    <svg
    className="w-11 h-11 md:w-16 md:h-16"

      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="0.5"
        width="63"
        height="63"
        rx="7.5"
        fill="white"
        stroke="#E9EEFE"
      />
      <path
        d="M52.2231 24.9546C51.6356 21.7851 48.7121 19.0374 45.5332 18.5437C43.6036 18.221 36.459 17.8163 32.8856 17.8585C29.3121 17.8163 22.1668 18.221 20.2379 18.5437C17.0582 19.0374 14.1348 21.7851 13.5473 24.9546C13.209 26.8718 12.8887 29.4859 12.8848 33.0632C12.8809 36.6405 13.2098 39.2546 13.5473 41.1718C14.134 44.3413 17.0575 47.0898 20.2371 47.5827C22.1661 47.9054 29.3114 48.3101 32.8848 48.2679C36.4582 48.3101 43.6028 47.9054 45.5325 47.5827C48.7114 47.0898 51.6348 44.3413 52.2223 41.1718C52.5606 39.2546 52.8801 36.6405 52.8848 33.0632C52.8895 29.4859 52.5614 26.8718 52.2231 24.9546Z"
        fill="#3759BE"
      />
      <path
        d="M32.8856 17.8585C29.3122 17.8163 22.1669 18.221 20.238 18.5437C17.0583 19.0374 14.1349 21.7851 13.5474 24.9554C13.2814 26.475 13.0988 28.008 13.0005 29.5476L13.0005 36.5788C13.0989 38.1179 13.2815 39.6504 13.5474 41.1694C13.6383 41.6534 13.7803 42.1263 13.9708 42.5804C16.6349 43.6965 19.4949 44.2697 22.3833 44.2663C34.406 44.2663 44.1528 34.5194 44.1528 22.4968C44.1535 21.1003 44.0203 19.7069 43.7552 18.3359C40.813 18.0734 35.7239 17.8288 32.8856 17.8585Z"
        fill="#5170CD"
      />
      <path
        d="M31.3128 41.482C31.3183 42.3828 30.6097 43.1094 29.7355 43.1008C26.9427 43.0747 24.1508 43.0125 21.3597 42.9141C20.4831 42.882 19.719 42.1422 19.669 41.2664C19.6175 40.3898 20.3081 39.6984 21.1987 39.718C24.03 39.7836 26.861 39.8255 29.6917 39.8438C30.1237 39.8485 30.5364 40.0234 30.8402 40.3306C31.144 40.6378 31.3144 41.0524 31.3144 41.4844L31.3128 41.482ZM39.5089 35.3539C39.5028 35.7863 39.3277 36.199 39.0211 36.5039C38.7144 36.8088 38.3007 36.9815 37.8683 36.9852C32.2954 37.0154 26.725 36.9935 21.1573 36.9195C20.2605 36.9063 19.5128 36.1844 19.4987 35.3078C19.4847 34.4313 20.2128 33.7219 21.1136 33.7227C26.7042 33.7362 32.2951 33.7401 37.8862 33.7344C38.0995 33.733 38.3109 33.774 38.5082 33.8548C38.7055 33.9357 38.8848 34.0549 39.0358 34.2055C39.1868 34.3561 39.3064 34.5351 39.3877 34.7323C39.4691 34.9294 39.5105 35.1407 39.5097 35.3539H39.5089Z"
        fill="white"
      />
      <path
        d="M19.6847 25.7191C19.812 24.134 21.1831 22.802 22.7659 22.7051C23.0487 22.6887 23.3612 22.6746 23.7081 22.6645C24.055 22.6543 24.3675 22.6504 24.6495 22.6504C26.2276 22.6504 27.462 23.9355 27.4784 25.5582C27.4784 25.8465 27.4784 26.1668 27.4714 26.5215C27.4644 26.8762 27.4558 27.1965 27.4433 27.4855C27.4088 28.2709 27.0795 29.0145 26.5212 29.5679C25.9628 30.1213 25.2164 30.4439 24.4308 30.4715C24.1409 30.4809 23.8198 30.4879 23.4644 30.4902C23.1089 30.4926 22.7878 30.4902 22.498 30.4855C20.8722 30.452 19.5815 29.1879 19.6003 27.6051C19.6003 27.3223 19.612 27.009 19.6276 26.6621C19.6433 26.3152 19.6628 26.002 19.6847 25.7191Z"
        fill="#E62D38"
      />
      <path
        d="M45.5247 13.0625C41.4552 13.0625 38.1567 16.3609 38.1567 20.4305C38.1567 24.5 41.4552 27.7984 45.5247 27.7984C49.5942 27.7984 52.8927 24.5 52.8927 20.4305C52.8927 16.3609 49.5942 13.0625 45.5247 13.0625Z"
        fill="#FDCE2F"
      />
      <path
        d="M45.5316 20.4069C46.7399 20.4069 47.7194 19.4274 47.7194 18.2191C47.7194 17.0108 46.7399 16.0312 45.5316 16.0312C44.3233 16.0312 43.3438 17.0108 43.3438 18.2191C43.3438 19.4274 44.3233 20.4069 45.5316 20.4069Z"
        fill="white"
      />
      <path
        d="M49.4689 24.1259C49.4689 24.4882 49.1749 24.7822 48.8127 24.7822H42.2505C41.8882 24.7822 41.5942 24.4882 41.5942 24.1259V23.6889C41.5942 22.362 42.6731 21.2832 43.9999 21.2832H47.0619C48.3887 21.2832 49.4676 22.362 49.4676 23.6889V24.1259H49.4689Z"
        fill="white"
      />
    </svg>
  );
};
export default DrivingLicenseIconWithWhiteBG;
